<template>
  <footer>
    <div class="container">
      <div class="sections">
        <div class="column footer-img">
          <router-link to="/">
            <img
              src="@/assets/images/footer-logo-skroutz-lm.svg"
              alt="skroutz last mile footer logo"
            />
          </router-link>
        </div>

        <div class="column">
          <i class="icon icon-support"></i>
          <div class="info-container">
            <h3>Χρήσιμες Πληροφορίες</h3>
            <router-link to="/privacy">
              Πολιτική Απορρήτου
            </router-link>
            <span class="permission-wrapper">
              Γενική Άδεια Ταχυδρομικών Υπηρεσιών,
              <pre>EETT, AM : 20-060</pre>
            </span>
          </div>
        </div>

        <div class="column">
          <i class="icon icon-support"></i>
          <div>
            <h3>Επικοινωνία</h3>
            <span>Τηλέφωνο: </span> &nbsp;
            <a href="tel:+302111982929">+30 21 1198 2929</a>
          </div>
        </div>
      </div>

      <div class="copyright">
        <p>
          <span>
            &copy; 20[0-9]{2} Skroutz A.E. All Rights and Lefts reserved.
          </span>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PageFooter'
};
</script>

<style lang="scss" scoped>
footer {
  border-top: 1px solid rgb(220, 220, 220);
  padding: 24px 0px;
  width: 100%;

  .footer-img > a {
    border: unset !important;
  }
  h3 {
    line-height: 18px;
    font-size: 14px;
    margin-top: 8px;
    margin-bottom: 0;
  }
  span,
  a {
    display: inline-block;
    line-height: 18px;
    color: rgb(112, 112, 112);
    margin-top: 8px;
  }
  a {
    width: fit-content;

    &:not(.icon) {
      border-bottom: 1px dotted currentcolor;
    }
    &:hover {
      border-bottom: 1px solid currentcolor;
      text-decoration: none;
    }
  }
  span pre {
    color: inherit;
    font: inherit;
  }
  .info-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: max-content;

    .permission-wrapper {
      max-width: 320px;

      pre {
        overflow: hidden;
        white-space: pre-wrap;
      }
    }
  }
  .copyright {
    margin-top: 56px;

    span {
      margin-bottom: 8px;
      line-height: 17px;
      font-size: 13px;
    }
  }
}
.sections {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}

@media (max-width: 734px) {
  footer {
    margin: 0px auto;
    font-size: 14px;

    img {
      width: 90px;
      height: 30px;
    }
  }
}

@media (min-width: 734px) and (max-width: 960px) {
  footer {
    margin: 0px auto;

    .sections {
      display: block;

      .column + .column {
        margin-top: 32px;
      }
    }

    img {
      width: 119px;
      height: 40px;
    }
  }
}

@media (min-width: 961px) {
  footer {
    margin: 0px auto;

    img {
      width: 164px;
      height: 55px;
    }
    h3 {
      line-height: 21px;
      font-size: 16px;
    }

    .copyright span {
      line-height: 18px;
      font-size: 14px;
    }
  }
}
</style>
